import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { TopSlider } from '../Common/TopSlider';
import { RecommandedSeller } from './RecommandedSeller';
import { PaymentMethod } from './PaymentMethod';
import { FeedBack } from './Feedback';
import  Service  from './Service';
import { CategoryList } from './CategoryList';
import { Header } from '../Common/Header';
import { Footer } from '../Common/Footer';
import ProductsUpload from '../../Models/ProductsUpload';
import {withTranslation} from "react-i18next";

class HomePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categories: [],
        }
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    componentWillMount() {
        ProductsUpload.getCategory().then(res => {
            this.setState({ categories: res.data.categories })
        })
    }



    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        const isTablet = (window.innerWidth < 1200 && window.innerWidth > 500);
        //for mobile responsive
        if (isMobile) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="">
                        <div className="container">
                            <div fixed="top" style={{ height: "95px" }}></div>
                            <div className="">
                                <div className="col-md-12 mt-3" style={{ paddingRight: "0px" }}>
                                    <TopSlider />
                                </div>
                            </div>
                        </div>
                        <div className="main">
                            <div className="">
                                <div className="mb-4">
                                    <div className="col-md-9">
                                        <div className="recommanded_seller_slider" style={{ padding: '0px' }}>
                                            {this.state.categories.map(category =>
                                                <div className="recommanded_seller_text mt-4" key={category.id}>
                                                    <div className="row">
                                                        <div className="col-md-10" style={{ backgroundColor: 'white', width: '800px' }}>
                                                            <strong>
                                                                <div className='floats floats-alt' style={{ backgroundColor: 'white', width: '800px' }}>
                                                                    <img src={require("../../assets/images/design.png")} height="20" width="20" className="" alt="" />
                                                                    &nbsp;{category.category}
                                                                </div>
                                                            </strong>
                                                        </div>
                                                    </div>
                                                    <RecommandedSeller id={category.id} />
                                                    <div className="" style={{ backgroundColor: 'white', fontSize: '12px', paddingLeft: '4px', paddingTop: '5px' }}>
                                                        <Link to={{
                                                            pathname: `/categories/${category.id}`,
                                                            state: { id: category.id , name: category.category}
                                                        }} >{this.props.t('0')}</Link>
                                                    </div>
                                                </div>
                                            )}
                                            {/*<Service />*/}
                                        </div>
                                    </div>
                                    <div className="col-md-3 ">
                                        <div>
                                            <FeedBack />
                                        </div>
                                        <div style={{ height: 'auto' }}>
                                            <CategoryList />
                                        </div>
                                        <div className="mt-3" style={{ height: '180px' }}>
                                            {/*<PaymentMethod />*/}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div >
            );
        }
        //for tablet view
        else if (isTablet) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="">
                        <div className="container">
                            <div fixed="top" style={{ height: "95px" }}></div>
                            <div className="">
                                <div className="mt-3">
                                    <TopSlider />
                                </div>
                            </div>
                        </div>
                        <div className="main">
                            <div className="container">
                                <div className="row mb-4">
                                    <div className="col-md-9">
                                        <div className="recommanded_seller_slider" style={{ padding: '0px' }}>
                                            {this.state.categories.map(category =>
                                                <div className="recommanded_seller_text mt-4" key={category.id}>
                                                    <div className="row">
                                                        <div className="col-md-10" style={{ backgroundColor: 'white', width: '800px' }}>
                                                            <strong>
                                                                <div className='floats floats-alt' style={{ backgroundColor: 'white', width: '800px' }}>
                                                                    <img src={require("../../assets/images/design.png")} height="20" width="20" className="" alt="" />
                                                                    &nbsp;{category.category}
                                                                </div>
                                                            </strong>
                                                        </div>
                                                        <div className="col-md-2 " style={{ backgroundColor: 'white', fontSize: '12px', paddingLeft: '16px', paddingTop: '5px' }}>
                                                            <Link to={{
                                                                pathname: `/categories/${category.id}`,
                                                                state: { id: category.id , name: category.category}
                                                            }} >{this.props.t('0')}</Link>
                                                        </div>
                                                    </div>
                                                    <RecommandedSeller id={category.id} />
                                                </div>
                                            )}
                                            {/*<Service />*/}
                                        </div>
                                    </div>
                                    <div className="col-md-3 ">
                                        <div>
                                            <FeedBack />
                                        </div>
                                        <div style={{ height: 'auto' }}>
                                            <CategoryList />
                                        </div>
                                        <div className="mt-3" style={{ height: '180px' }}>
                                            {/*<PaymentMethod />*/}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div >
            );
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="">
                        <div className="container" style={{paddingRight:'10px'}}>
                            <div fixed="top" style={{ height: "95px" }}></div>
                            <div className="">
                                <div className=" mt-3 pr-0">
                                    <TopSlider />
                                </div>
                            </div>
                        </div>
                        <div className="main">
                            <div className="container">
                                <div className="row mb-4">
                                    <div className="col-md-9">
                                        <div className="recommanded_seller_slider" style={{ padding: '0px' }}>
                                            {this.state.categories.map(category =>
                                                <div className="recommanded_seller_text mt-4" key={category.id}>
                                                    <div className="row">
                                                        <div className="col-md-10" style={{ backgroundColor: 'white', width: '800px' }}>
                                                            <strong>
                                                                <div className='floats floats-alt' style={{ backgroundColor: 'white', width: '800px' }}>
                                                                    <img src={require("../../assets/images/design.png")} height="20" width="20" className="" alt="" />
                                                                    &nbsp;{category.category}
                                                                </div>
                                                            </strong>
                                                        </div>
                                                        <div className="col-md-2 " style={{ backgroundColor: 'white', fontSize: '12px', paddingLeft: '16px', paddingTop: '5px' }}>
                                                            <Link to={{
                                                                pathname: `/categories/${category.id}`,
                                                                state: { id: category.id , name: category.category}
                                                            }} >{this.props.t('0')}</Link>
                                                        </div>
                                                    </div>
                                                    <RecommandedSeller id={category.id} />
                                                </div>
                                            )}
                                            {/*<Service />*/}
                                        </div>
                                    </div>
                                    <div className="col-md-3 ">
                                        <div>
                                            <FeedBack />
                                        </div>
                                        <div style={{ height: 'auto' }}>
                                            <CategoryList />
                                        </div>
                                        <div className="mt-3" style={{ height: '180px' }}>
                                            {/*<PaymentMethod />*/}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div >
            );
        }

    }
}

export { HomePage };
HomePage = withTranslation('src_Components_HomePage_HomePage')(HomePage);
